import React from "react";
import { StyleSheet, Platform } from "react-native";
import { injectIntl } from "react-intl";
import { Section, Block } from "react-native-responsive-layout";
import { material } from "react-native-typography";
import styled, { withTheme } from "styled-components/native";
import { BackButton, Button } from "cci-component";
import { localize } from "cci-utility";

/* Row container for all of the titles (page and sub titles) */
const TitleWrapper = withTheme(
  ({
    theme,
    marginTop,
    marginBottom,
    style,
    lgStyle,
    children,
    rightChildren
  }) => {
    const styles = StyleSheet.create({
      wrapper: {
        flexDirection: "row",
        alignItems: "center"
      },

      narrow: {
        marginLeft: 10
      },

      wide: {
        marginLeft: theme.titleNegativeMargin || -50
      }
    });

    return (
      <Section style={{ ...styles.wrapper, marginTop, marginBottom }}>
        <Block
          size="stretch"
          style={[styles.wrapper, styles.narrow, style]}
          lgStyle={[styles.wrapper, styles.wide, lgStyle]}
          children={children}
        />
        {rightChildren}
      </Section>
    );
  }
);

/* Page title that appears along the top of the page */
const Title = styled.Text`
  ${material.headlineObject};

  color: ${props => props.theme.fontColor};
  text-transform: ${props => props.theme.titleInspectUppercase ? 'uppercase' : 'none'};
  letter-spacing: ${props => props.theme.titleInspectSpacing || 4}px;
`;

/* Subtitle text to give a heading to subsections within the page */
const SubtitleText = styled.Text`
  ${material.subheadingObject};

  color: ${props => props.theme.fontColor};
  letter-spacing: ${props => props.theme.subtitleInspectSpacing || 2}px;
`;
/* Main page title text only */
const PageTitle = injectIntl(
  withTheme(({ intl, title, children, values, theme, ...restProps }) => (
    <TitleWrapper
      marginBottom={theme.inspectTitleBottomMargin || 40}
      {...restProps}
    >
      {children}

      {/* Title text */}
      <Title>{localize(intl, title, values)}</Title>
    </TitleWrapper>
  ))
);

/* Main page title which also contains a back button when on native devices */
const NavPageTitle = props => (
  <PageTitle {...props}>
    {/* Back button for mobile devices */}
    {Platform.OS !== "web" && <BackButton />}
  </PageTitle>
);

/* Subtitle for pages, which is a great separator for certain sections in a page */
const Subtitle = injectIntl(({ intl, title, values, ...restProps }) => (
  <TitleWrapper marginTop={25} marginBottom={10} {...restProps}>
    <SubtitleText>{localize(intl, title, values)}</SubtitleText>
  </TitleWrapper>
));

const InspectTitle = props => <NavPageTitle {...props} />;

const InspectSubtitle = ({ title, ...restProps }) => (
  <Subtitle title={title} {...restProps} />
);

/* Subtitle text to give a heading to subsections within the page */
const ListTitle = styled.Text`
  ${material.subheadingObject};

  color: ${props => props.theme.fontColor};
  font-weight: bold;
  font-size: 18px;
`;

/* Subtitle text to give a heading to subsections within the page */
const ListSubtitle = styled.Text`
  ${material.subheading};

  color: ${props => props.theme.fontColor};
  font-size: 18px;
`;

export {
  PageTitle,
  NavPageTitle,
  Subtitle,
  InspectTitle,
  InspectSubtitle,
  Title,
  SubtitleText,
  ListTitle,
  ListSubtitle
};
